import React from "react";
import { Autocomplete, CircularProgress, TextField } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useClipsStore } from "./ClipsStore/clipsStore";

export const UserDropDownSMTP = ({
  navBarCollapsed,
}: {
  navBarCollapsed: boolean;
}) => {
  const {
    groupOptionsSMTP,
    userDropDownValueSMTP,
    setUserDropDownValueSMTP,
    setCameraDropDownValueSMTP,
    setGroupIDSMTP,
    setSiteDropDownValueSMTP,
    setSiteOptionsSMTP,
    setUserFiltersSMTP,
    getAllSitesClipsSMTP,
    setCameraOptionsSMTP,
    loadingGroupsSMTP,
    getDownloadURLSMTP,
    setDownloadURLSMTP,
  } = useClipsStore();
  const navigate = useNavigate();

  // Create a Set to track unique names and ensure we only add each name once
  const uniqueNames = new Set<string>();
  const options: string[] = [];

  const optionUserIds = new Map();

  const allGroupOptions = JSON.parse(localStorage.parentAccounts);

  // First pass: collect unique names and their corresponding IDs
  (allGroupOptions || []).forEach((object: any) => {
    // if (object.group) {
    if (!uniqueNames.has(object.name)) {
      uniqueNames.add(object.name);
      options.push(object.name);
      optionUserIds.set(object.name, object.id);
    }
    // }
  });

  const optionUserNames = new Map();
  // Second pass: populate optionUserNames (this could be the same as optionUserIds)
  (allGroupOptions || []).forEach((object: any) => {
    // if (object.group) {
    optionUserNames.set(object.name, object.id);
    // }
  });

  return (
    <div key="user_dropdown_smtp">
      <Autocomplete
        value={userDropDownValueSMTP}
        disablePortal
        options={options}
        onChange={(event, value: any) => {
          if (value !== null) {
            setUserDropDownValueSMTP(value);
            setCameraDropDownValueSMTP(null);
            setGroupIDSMTP(optionUserIds.get(value));
            setSiteDropDownValueSMTP(null);
            setSiteOptionsSMTP([]);
            getAllSitesClipsSMTP(optionUserIds.get(value), navigate);
            setUserFiltersSMTP((previousState: any) => {
              return {
                ...previousState,
                user: optionUserNames.get(value),
                group_id: optionUserIds.get(value),
                site_ids: [],
                camera_ids: [],
              };
            });
            getDownloadURLSMTP(navigate);
          } else {
            // setFetchingFilteredData(true);
            setUserDropDownValueSMTP(value);
            setSiteDropDownValueSMTP(null);
            setSiteOptionsSMTP([]);
            setCameraDropDownValueSMTP(null);
            setCameraOptionsSMTP([]);
            setUserFiltersSMTP((previousState: any) => {
              return {
                ...previousState,
                user: "testuser",
                group_id: null,
                site_ids: [],
                camera_ids: [],
              };
            });
            setDownloadURLSMTP("");
          }
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Group"
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <React.Fragment>
                  {loadingGroupsSMTP ? (
                    <CircularProgress color="inherit" size={20} />
                  ) : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
            }}
            autoComplete="off"
            helperText="*Required"
            sx={!navBarCollapsed ? { width: 150 } : { width: 175 }}
          />
        )}
      />
    </div>
  );
};
